// extracted by mini-css-extract-plugin
export var circle = "qydNU";
export var circleContainer = "aLmiQ";
export var container = "_6E7-z";
export var line = "IsyMd";
export var message = "db6Rw";
export var navItem = "mZ-9v";
export var navText = "_21zv9";
export var phone = "ql12A";